module.exports = __webpack_public_path__ + "img/thumbnail_ProboscisMonkey_j_normal.e9265af3.png";